import { useTranslation } from 'react-i18next';
import WarningIcon from 'assets/images/icons/warning.svg?react';
import ExternalLinkIcon from 'assets/images/icons/external-link.svg?react';
import { InboxVrboOfflineBookingAlertContainer } from './InboxVrboOfflineBookingAlert.styles';

export const VRBO_OFFLINE_BOOKING_FAQ_URL =
  'https://help.hostfully.com/en/articles/11660999-frequently-asked-questions-faqs-about-vrbo';

const InboxVrboOfflineBookingAlert = () => {
  const { t } = useTranslation();

  return (
    <InboxVrboOfflineBookingAlertContainer data-testid="inbox-vrbo-offline-booking-alert">
      <WarningIcon aria-hidden="true" />
      <div>
        <h4>{t('pageInbox.messages.vrboOfflineBooking.title')}</h4>
        <div>{t('pageInbox.messages.vrboOfflineBooking.description')}</div>
        <a href={VRBO_OFFLINE_BOOKING_FAQ_URL} target="_blank" rel="noreferrer">
          {t('pageInbox.messages.vrboOfflineBooking.learnMore')}
          <ExternalLinkIcon aria-hidden="true" />
        </a>
      </div>
    </InboxVrboOfflineBookingAlertContainer>
  );
};

export default InboxVrboOfflineBookingAlert;
